export const container = 'flex flex-col w-[400px] p-24px '

export const iconAndDetailsContainer = 'flex flex-col'

export const headingStyles = (theme: any): string =>
   `text-lg-semibold ${theme.boardHeading}`

export const descriptionStyles = (theme: any): string =>
   `text-sm-regular ${theme.description} mt-4px break-word max-w-sm`

export const deleteButtonsContainerClassName = `flex mt-32px`

export const headingAndDescriptionContainer = 'flex flex-col mt-16px'

export const leaveButtonStyles = 'w-full h-44px '

export const ConfirmButtonStyles = 'w-full h-44px'
